class DeferredSection extends HTMLElement {
  observer = undefined;
  loaded = false;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeObserver();
  }

  disconnectedCallback() {
    this.observer?.unobserve(this);
  }

  initializeObserver() {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadSection();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadSection() {
    if (this.loaded) return;
    this.loaded = true;

    const sectionId = this.dataset.sectionId;
    const url = `${window.location.pathname}?section_id=${sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const sectionContent = html.querySelector('.shopify-section') || html.firstElementChild;

        if (sectionContent) {
          this.innerHTML = sectionContent.innerHTML;
          
          this.reinjectScripts();
          
          this.dispatchEvent(new CustomEvent('deferred-section:loaded', { bubbles: true }));
        }
      })
      .catch((e) => {
        console.error('Error loading deferred section:', e);
      });
  }

  reinjectScripts() {
    this.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

customElements.define('deferred-section', DeferredSection);